import React from "react"

import { FeatureGalleryItem } from "../../../components/_V2/FeaturesGallery"
import { StaticImage } from "gatsby-plugin-image"

// @ts-ignore
import ChevronRight from "../../../assets/svg/chevronRight.svg"

import mediaContent from "./mediaContent.module.scss"
import styles from "./styles.module.scss"
import {Locales} from "../../../localization/types";

export const getData = (locale: Locales) => {
	if (locale === 'ru-KZ') {
		return {
			features: [
				{
					desktopContentWidth: 540,
					tabName: "Web-kassa",
					desktopTitle: <>Надёжная онлайн-касса для предпринимателей</>,
					desktopContent: (
						<p className={mediaContent.smallDescription}>
							Web-kassa работает на любом устройстве, это позволяет
							экономить на оборудовании. Интеграции позволяют
							фискализировать платёжные терминалы и онлайн продажи.
						</p>
					),
					mediaContent: (
						<div className={mediaContent.imageWrapper}>
							<StaticImage
								className={mediaContent.image}
								src="./assets/integrations-products-1-kz.png"
								alt={"интеграция quick resto и Web-kassa"}
								objectFit={"contain"}
								placeholder={"blurred"}
								quality={90}
							/>
						</div>
					),
					backdropContent: <div className={styles.backdrop}/>,
				},
				{
					desktopContentWidth: 540,
					tabName: "Glovo",
					desktopTitle: "Получай заказы от лояльных пользователей",
					desktopContent: (
						<p className={mediaContent.smallDescription}>
							Интеграция с Glovo помогает рестораторам расширить
							свою клиентскую базу и увеличить заказы, предоставляя
							клиентам удобную опцию доставки еды.
						</p>
					),
					mediaContent: (
						<div className={mediaContent.imageWrapper}>
							<StaticImage
								className={mediaContent.image}
								src="./assets/integrations-products-2-kz.png"
								alt={"интеграция quick resto и Glowo"}
								objectFit={"contain"}
								placeholder={"blurred"}
								quality={90}
							/>
							<span className={mediaContent.soonTag}>скоро</span>
						</div>
					),
					backdropContent: <div className={styles.backdrop}/>,
				},
				{
					desktopContentWidth: 540,
					tabName: "Wolt",
					desktopTitle: "Привлекай новых гостей в свой ресторан",
					desktopContent: (
						<p className={mediaContent.smallDescription}>
							Интеграция с WOLT позволяет расширить своё
							онлайн-присутствие и привлекать новых клиентов через
							популярную платформу для доставки еды.
						</p>
					),
					mediaContent: (
						<div className={mediaContent.imageWrapper}>
							<StaticImage
								className={mediaContent.image}
								src="./assets/integrations-products-3-kz.png"
								alt={"интеграция quick resto и Wolt"}
								objectFit={"contain"}
								placeholder={"blurred"}
								quality={90}
							/>
							<span className={mediaContent.soonTag}>скоро</span>
						</div>
					),
					backdropContent: <div className={styles.backdrop}/>,
				},
				{
					desktopContentWidth: 540,
					tabName: "Chocofood",
					desktopTitle: "Расширяй горизонты своего бизнеса",
					desktopContent: (
						<p className={mediaContent.smallDescription}>
							Интеграция  увеличивает видимость в онлайн
							и доступность ресторана для клиентов. Chocofood
							помогает быстро и легко расширить бизнес через
							онлайн-заказы еды.
						</p>
					),
					mediaContent: (
						<div className={mediaContent.imageWrapper}>
							<StaticImage
								className={mediaContent.image}
								src="./assets/integrations-products-4-kz.png"
								alt={"интеграция quick resto и Chocofood"}
								objectFit={"contain"}
								placeholder={"blurred"}
								quality={90}
							/>
							<span className={mediaContent.soonTag}>скоро</span>
						</div>

					),
					backdropContent: <div className={styles.backdrop}/>,
				},
			],
		} as {
			features: Array<FeatureGalleryItem>
		}
	} else if (locale === 'ru-BY') {
		return {
			features: []
		} as {
			features: Array<FeatureGalleryItem>
		}
	}

	return {
		features: [
			{
				desktopContentWidth: 490,
				tabName: "ЕГАИС",
				desktopTitle: <>Каждая капля на&nbsp;счету</>,
				desktopContent: (
					<p className={mediaContent.smallDescription}>
						В&nbsp;системе настроена интеграция с&nbsp;государственными системами
						учёта алкоголя. Удобная выгрузка данных для алкодеклараций, гашение
						марок, подтверждение алкогольных накладных, списание остатков.
					</p>
				),
				mediaContent: (
					<div className={mediaContent.imageWrapper}>
						<StaticImage
							className={mediaContent.image}
							src="./assets/integrations-products-1.png"
							alt={"интеграция quick resto и ЕГАИС"}
							objectFit={"contain"}
							placeholder={"blurred"}
							quality={90}
						/>
					</div>
				),
				backdropContent: <div className={styles.backdrop}/>,
			},
			{
				desktopContentWidth: 490,
				tabName: "Меркурий",
				desktopTitle: "Учёт фермерских продуктов",
				desktopContent: (
					<p className={mediaContent.smallDescription}>
						Регистрация операций с&nbsp;продуктами животного происхождения, работа
						с&nbsp;ветеринарными сопроводительными документами (ВСД),
						автоматизация работы с&nbsp;электронными документами
						от&nbsp;поставщиков.
					</p>
				),
				mediaContent: (
					<div className={mediaContent.imageWrapper}>
						<StaticImage
							className={mediaContent.image}
							src="./assets/integrations-products-2.png"
							alt={"интеграция quick resto и меркурий"}
							objectFit={"contain"}
							placeholder={"blurred"}
							quality={90}
						/>
					</div>
				),
				backdropContent: <div className={styles.backdrop}/>,
			},
			{
				desktopContentWidth: 490,
				tabName: "Честный знак",
				desktopTitle: "Маркировка товаров",
				desktopContent: (
					<p className={mediaContent.smallDescription}>
						Подача сведений о&nbsp;выбытии молочной продукции, подлежащей
						маркировке, при розничной реализации, включая продажу через кассу.
						Передача сведений об&nbsp;обороте маркированной воды (объемно-сортовой
						учет).
					</p>
				),
				mediaContent: (
					<div className={mediaContent.imageWrapper}>
						<StaticImage
							className={mediaContent.image}
							src="./assets/integrations-products-3.png"
							alt={"интеграция quick resto и честный знак"}
							objectFit={"contain"}
							placeholder={"blurred"}
							quality={90}
						/>
					</div>
				),
				backdropContent: <div className={styles.backdrop}/>,
			},
		],
	} as {
		features: Array<FeatureGalleryItem>
	}
}
